import React from 'react';
import { useTranslation } from 'react-i18next';

import { Visible, Hidden } from 'components/Grid';

import {
  Section,
  Gradient,
  Container,
  Text,
} from './styles';

const MiddleWave = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <Gradient src="/assets/images/wave/background.png" />
      <Container>
        <Hidden xs>
          <Text>{t('WAVE.MIDDLE_WAVE.TEXT')}</Text>
        </Hidden>
        <Visible xs>
          <Text.xs>{t('WAVE.MIDDLE_WAVE.TEXT')}</Text.xs>
        </Visible>
      </Container>
    </Section>
  );
};

export default MiddleWave;
